import {
    collection,
    query,
    getDocs,
    doc,
    writeBatch,
    QueryDocumentSnapshot,
    DocumentData,
    where,
    setDoc,
    deleteDoc,
} from 'firebase/firestore';
import { isNumber } from 'lodash';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { Exercise } from '../types';

const MAX_BATCH_SIZE = 10;

const mapSnapshotToExercise = (doc: QueryDocumentSnapshot<DocumentData>) => {
    return {
        ...doc.data(),
        id: doc.id,
    } as Exercise;
};

export const getExercisesFirebase = async (ids: string[]) => {
    const collectionPath = collection(db, DbCollections.Exercises);
    const batches = [];
    const idList = [...ids];

    while (idList.length) {
        const batch = idList.splice(0, MAX_BATCH_SIZE);
        batches.push(getDocs(query(collectionPath, where('id', 'in', [...batch]))));
    }

    const exercises = [] as Exercise[];

    await Promise.all(batches).then((content) =>
        content.flat().map(async (querySnapshot) => {
            querySnapshot.forEach(async (doc) => {
                exercises.push(mapSnapshotToExercise(doc));
            });
        }),
    );

    return exercises.sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));
};

export const saveExercisesFirebase = async (exercises: Exercise[]) => {
    const batch = writeBatch(db);
    exercises.forEach((exercise) => {
        const docRef = doc(db, DbCollections.Exercises, exercise.id);
        batch.set(docRef, exercise);
    });
    await batch.commit();

    return exercises;
};

export const saveExerciseFirebase = async (exercise: Exercise) => {
    const exerciseData = {
        ...exercise,
        renewalPercent: isNumber(exercise.renewalPercent) ? exercise.renewalPercent : Number(exercise.renewalPercent),
        tasks: exercise.tasks ?? [],
    };
    await setDoc(doc(db, DbCollections.Exercises, exercise.id), exerciseData);
    return exercise;
};

export const deleteExerciseFirebase = async (id: string) => {
    await deleteDoc(doc(db, DbCollections.Exercises, id));
    return id;
};
